<template>
    <div>
        <transition name="fade">
            <div :key="1" v-if="formIsSend" class="login-form-wrapper">
                <form-is-done />
            </div>
            <div :key="2" v-else class="login-form-wrapper">
                <form
                    class="login-form"
                    :class="{ 'login-form--shake': formIsShaking }"
                    @submit.prevent="submitForm"
                >
                    <div class="inpt-group">
                        <text-input
                            class="field"
                            v-model="creds.login"
                            :error="formErrors.username != null"
                            inputId="login"
                            label="Логин*"
                            label-alignment="left"
                            required
                        />
                        <span
                            v-if="formErrors.username"
                            class="help-text error-msg error"
                        >
                        {{ formErrors.username }}
                        </span>
                        <text-input
                            class="field"
                            v-model="creds.email"
                            inputId="email"
                            input-type="email"
                            :error="formErrors.email != null"
                            label="Email*"
                            label-alignment="left"
                            required
                        />
                        <span
                            v-if="formErrors.email"
                            class="help-text error-msg error"
                        >
                        {{ formErrors.email }}
                        </span>
                        <text-input
                            v-model="creds.fullName"
                            class="field"
                            inputId="fullName"
                            label="ФИО*"
                            label-alignment="left"
                            required
                        />
                        <text-input
                            v-model="creds.organization"
                            class="field"
                            inputId="organization"
                            label="Ваша организация*"
                            label-alignment="left"
                        />
                        <text-input
                            v-model="creds.post"
                            class="field"
                            inputId="post"
                            label="Ваша дожность*"
                            label-alignment="left"
                        />
                    </div>
                    <div class="btn-group">
                        <v-button
                            type="button"
                            @click="backToLoginPage"
                            class="login-form-submit"
                            label="<"
                        />
                        <v-button class="login-form-submit" label="Получить пароль на почту" />
                    </div>
                </form>
                    <logos />
            </div>
        </transition>
    </div>
</template>

<script>
  import TextInput from "../form_components/TextInput";
  import FormIsDone from "./FormIsDone";
  import vButton from "../vButton";
  import { AuthAPI } from "api-client";
  import Logos from "../Logos";

  export default {
    name: "Registration.vue",
    components: {
      TextInput,
      vButton,
      FormIsDone,
      Logos
    },
    data() {
      return {
        layout: "simple-layout",
        formIsSend: false,
        creds: {
          login: "",
          email: "",
          fullName: "",
          organization: "",
          post: ""
        },
        formIsShaking: false
      };
    },
    methods: {
      shakeForm() {
        this.formIsShaking = true;
        window.setTimeout(() => this.formIsShaking = false, 100)
      },
      async submitForm() {
        const formData = new FormData();
        formData.set("username", this.creds.login);
        formData.set("email", this.creds.email);
        formData.set("extended_name", this.creds.fullName);
        formData.set("organization", this.creds.organization);
        formData.set("position", this.creds.post);
        try {
          await AuthAPI.requestAccount(formData);
          this.formIsSend = true;
          this.callSubmitEmmit();
        } catch (e) {
          this.shakeForm()
          this.$store.commit('setErrors', { form: 'registration', errors: e });
        }
      },
      callSubmitEmmit() {
        this.$emit("submitted");
      },
      refreshForm() {
        this.formIsSend = false;
        this.creds = {
          login: "",
          email: "",
          fullName: "",
          organization: "",
          post: ""
        }
      },
      backToLoginPage() {
        this.$store.commit('clearErrors')
        this.$router.push({name: 'login'})
      }
     },
    computed: {
      formErrors() {
        return this.$store.getters.errorsPretty.registration
      }
    }
  };
</script>


<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
</style>
<style scoped lang="sass">
    @import '../../assets/sass/animations'

    .field
        flex-grow: 1
        padding-bottom: gridSteps(1)

    .btn-group
        display: flex
        width: 100%
        justify-content: space-evenly
        margin: gridSteps(1) gridSteps(0) gridSteps(3) gridSteps(0)

        button
            margin: 0 gridSteps(2) 0 gridSteps(2)

    .inpt-group
        width: 500px
        flex-direction: column
        display: flex
        padding: 0 gridSteps(5) 0 gridSteps(5)

    .login-form-wrapper
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

    .login-form
        width: 500px
        display: flex
        flex-direction: column
        align-items: center

    .login-form--shake
        animation: shake 100ms

    .login-form-submit
        margin-top: gridSteps(2)

    .text-input-wrapper
        margin-bottom: 0 !important

    .error-msg
        margin-bottom: gridSteps(1)
</style>
